import { useEffect } from 'react';
import { GA_ID } from '../constants/Config';

const useGoogleAnalytics = () => {
  useEffect(() => {
    if (!GA_ID) {
      console.warn('Google Analytics ID not found in config.js');
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', GA_ID, { send_page_view: false });
    };
  }, []);
};

export default useGoogleAnalytics;
